// Policy service
//
// A policy is defined by:
// - the path or resource to be accessed
// - the current clientID
// - the HTTP method
//
// The result of a call to isAllowed() is a boolean.
// isAllowed() checks the policy for a request and returns true or false
//
import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";

import { SURF_CUSTOMERS, SURF_ROLES } from "../helpers/userroles";
import { AuthService } from "./authservice";

export { SURF_CUSTOMERS, SURF_ROLES };

@Injectable()
export class PolicyService {
  private auth = inject(AuthService);
  private route = inject(Router);

  isAllowed(resource: string, action: "GET" | "POST" | "PUT" | "DELETE") {
    return this.checkLocal(resource, action);
  }

  checkLocal(resource: string, action: "GET" | "POST" | "PUT" | "DELETE"): boolean {
    const currentUser = this.auth.currentUser();
    // no resource given? then use the current route.
    const requestedResource = resource || this.route.routerState.snapshot.url;
    const appliedRoles = action === "GET" ? SURF_ROLES : SURF_ROLES.filter((role) => role !== "SuperuserRO");

    const customerId = this.auth.viewingCustomer().customerId;
    const isDomainsAdmin = this.auth.hasRole(["surfdomeinen_admins"]);
    const specialAccess = this.auth.hasRole(appliedRoles) && SURF_CUSTOMERS.includes(customerId);
    const isOwnCustomer = customerId === currentUser.customerId;

    if (requestedResource.startsWith("/domains")) {
      return isDomainsAdmin || specialAccess || isOwnCustomer || this.auth.isInviteUser();
    }

    return false;
  }
}
